import "./styles/app";

export default () => {
  window.onload = () => {
    location.hash && document.querySelector(location.hash).scrollIntoView();
    document.body.addEventListener("scroll", () => {
      const tab = document.querySelector(".awards_2022-tab");
      if (tab) {
        if (document.body.scrollTop >= 44) {
          tab.style.opacity = 1;
          document.body.style.height = "calc(100% - 44px)";
          document.body.style.marginTop = "44px";
        } else {
          tab.style.opacity = 0;
          document.body.style.height = "100%";
          document.body.style.marginTop = "0";
        }
      }

      document
        .querySelectorAll(".awards_2022-step__block-title")
        .forEach(item => {
          document
            .querySelector(`.${item.id}`)
            .classList.remove("awards_2022-tab-item--active");
          const { top } = item.getBoundingClientRect();
          if (top <= 50 && top > -206) {
            document
              .querySelector(`.${item.id}`)
              .classList.add("awards_2022-tab-item--active");
          } else {
            document
              .querySelector(`.${item.id}`)
              .classList.remove("awards_2022-tab-item--active");
          }
        });
    });

    const units = document.querySelectorAll(".card-area__card");
    if (units.length > 0) {
      units.forEach(unit => {
        unit.addEventListener("click", function() {
          const href = this.getAttribute("href");
          window.open(href, "_blank");
        });
      });
    }

    document.querySelectorAll(".awards_2022-tab-item").forEach(item => {
      item.addEventListener("click", function() {
        document.querySelectorAll(".awards_2022-tab-item").forEach(tab => {
          tab.classList.remove("awards_2022-tab-item--active");
        });
        this.classList.add("awards_2022-tab-item--active");
      });
    });
  };
};
